export enum FriendInvitationState {
    Loading,
    AccountIsFound,
    Success,
    Fail
}